import { Trial_Status, TrialHeaderQuery, TrialHeaderQueryHookResult } from "@generated/graphql";
import TabLayout from "layout/TabLayout";
import InfoTab from "./InfoTab";
import ResultTab from "./ResultTab";

interface TestingContentProps {
  trial: TrialHeaderQuery["trial"] | undefined;
  isCreate: boolean;
  refetchTrialHeader: TrialHeaderQueryHookResult["refetch"];
}

const TestingContent = ({ trial, isCreate, refetchTrialHeader }: TestingContentProps) => {
  const TABS = [
    {
      title: "Общая информация",
      id: "info",
      component: <InfoTab refetchTrialHeader={refetchTrialHeader} />,
    },
    {
      title: "Результаты",
      id: "result",
      component: <ResultTab />,
      disabled: isCreate || trial?.status !== Trial_Status.Completed,
    },
  ];

  return (
    <TabLayout
      tabs={TABS}
      defaultTab='info'
    />
  );
};

export default TestingContent;
